import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Inject, Optional, Component, EventEmitter, Output, ViewChild, Input, LOCALE_ID, NgModule } from '@angular/core';
import * as i4$1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, throwError, Observable, iif, BehaviorSubject, of, zip } from 'rxjs';
import { map, switchMap, tap, catchError, takeUntil, finalize, timeout } from 'rxjs/operators';
import * as i1 from '@ebootis/common';
import { SFX_SERVICE_INVOKER, OpenModelServletService } from '@ebootis/common';
import * as i5 from '@angular/common';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import CryptoES from 'crypto-es';
import { HttpParams, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i3 from '@ebootis/utilities';
import { IndexedDBService, OFFLINE_DB_NAME, UtilitiesModule } from '@ebootis/utilities';
import * as i4 from 'ngx-cookie-service';
import { CookieService } from 'ngx-cookie-service';
import * as i2 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i6 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i10 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i3$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i9 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i13 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i14 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i3$2 from '@angular/router';
import * as i4$2 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import * as i7 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';

class ChangePasswordIntl {
    constructor() {
        this.changes = new Subject();
    }
    static { this.ɵfac = function ChangePasswordIntl_Factory(t) { return new (t || ChangePasswordIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ChangePasswordIntl, factory: ChangePasswordIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangePasswordIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class LoginService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    logout() {
        return this.apiService.post("api/logout");
    }
    login(credentials) {
        return this.apiService.post('api/login', credentials);
    }
    resetPassword(user, returnUrl) {
        return this.apiService.post("api/resetpassword", { user: user, url: returnUrl });
    }
    newPassword(p_password, p_queryParamHash) {
        return this.apiService.post("api/newpassword", { password: p_password, q: p_queryParamHash });
    }
    changePw(p_oldPw, p_newPw) {
        return this.apiService.post("api/changepassword", { oldPassword: p_oldPw, newPassword: p_newPw });
    }
    static { this.ɵfac = function LoginService_Factory(t) { return new (t || LoginService)(i0.ɵɵinject(i1.ApiService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginService, factory: LoginService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.ApiService }]; }, null); })();

class LoginIntl {
    constructor() {
        this.changes = new Subject();
        this.titleText = 'Anmeldung';
        this.userPlaceholder = 'Benutzername';
        this.userErrorRequired = 'Bitte einen Benutzernamen angeben';
        this.passwordPlaceholder = 'Passwort';
        this.passwordIncorrect = 'Passwort ist nicht korrekt';
        this.passwordErrorRequired = 'Bitte ein Passwort angeben';
        this.qrcodeDescriptionText = 'Öffnen Sie jetzt Ihre Authenticator-App und scannen Sie folgenden QR-Code:';
        this.secretDescriptionText = 'Alternativ können Sie auch folgenden Schlüssel manuell eingeben:';
        this.authcodePlaceholder = '6-stelliger Authentisierungs-Code';
        this.authcodeErrorRequired = 'Bitte einen Authentisierungs-Code angeben';
        this.authcodeErrorMinlength = 'Authentisierungs-Code muss 6 Stellen enthalten';
        this.trustedDeviceText = 'Gerät merken';
        this.deviceNamePlaceholder = 'Gerätename';
        this.deviceNameErrorRequired = 'Bitte einen Gerätenamen angeben';
        this.loginButtonText = 'Anmelden';
        this.passwortResetButtonText = 'Passwort zurücksetzen?';
        this.tfaResetButtonText = 'Zwei-Faktor-Authentisierung zurücksetzen';
        this.tfaScratchcodeButtonText = 'Einmal-Code per E-Mail zusenden';
        this.buttonOk = 'Ok';
        this.tryOfflineTitle = 'Online Anmeldung fehlgeschlagen';
        this.tryOfflineText = 'Möchten Sie es offline versuchen?';
        this.buttonCancel = 'Abbrechen';
        this.noAuthAppTitle = 'Kein Zugriff auf die Authenticator-App?';
    }
    static { this.ɵfac = function LoginIntl_Factory(t) { return new (t || LoginIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginIntl, factory: LoginIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

const REVISION = new InjectionToken('app.revision');

// GENERATED FILE. DO NOT EDIT!
// GENERATOR       de.ebootis.sfx.sfxGen.TypescriptGen
class IOpenModelServlet {
    constructor(sfxService) {
        this.sfxService = sfxService;
        this.m_remoteName = 'openModelServlet';
    }
    getEmailFromAddress(webApp) {
        let params = new HttpParams();
        if (webApp != null) {
            params = params.set('webApp', webApp.toString());
        }
        return this.sfxService.get(this.m_remoteName, "getEmailFromAddress", params);
    }
    getExternalBaseUrl(webApp) {
        let params = new HttpParams();
        if (webApp != null) {
            params = params.set('webApp', webApp.toString());
        }
        return this.sfxService.get(this.m_remoteName, "getExternalBaseUrl", params);
    }
    getUserDevices() {
        return this.sfxService.get(this.m_remoteName, "getUserDevices");
    }
    removeUserDevice(userDeviceOid) {
        let params = {};
        if (userDeviceOid != null) {
            params.userDeviceOid = userDeviceOid;
        }
        return this.sfxService.post(this.m_remoteName, "removeUserDevice", params);
    }
    static { this.ɵfac = function IOpenModelServlet_Factory(t) { return new (t || IOpenModelServlet)(i0.ɵɵinject(SFX_SERVICE_INVOKER)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IOpenModelServlet, factory: IOpenModelServlet.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IOpenModelServlet, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SFX_SERVICE_INVOKER]
            }] }]; }, null); })();
(function (IOpenModelServlet) {
    //TypeDesc("de.ebootis.fet.openModel.impl.servlet.IOpenModelServlet$UserDevice")
    class UserDevice {
    }
    IOpenModelServlet.UserDevice = UserDevice;
})(IOpenModelServlet || (IOpenModelServlet = {}));

class UserDeviceService {
    constructor(openModel) {
        this.openModel = openModel;
    }
    getUserDevices() {
        return this.openModel.getUserDevices();
    }
    removeUserDevice(device) {
        return this.openModel.removeUserDevice(device.oid);
    }
    static { this.ɵfac = function UserDeviceService_Factory(t) { return new (t || UserDeviceService)(i0.ɵɵinject(IOpenModelServlet)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserDeviceService, factory: UserDeviceService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserDeviceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: IOpenModelServlet }]; }, null); })();

class LoginDBService extends IndexedDBService {
    constructor(m_dbNameBase) {
        super();
        this.m_dbNameBase = m_dbNameBase;
        this.USER = "User";
        this.DB_VERSION = 1000;
    }
    open() {
        if (this.m_dbNameBase)
            return super.open(this.m_dbNameBase, this.DB_VERSION);
        else
            return throwError(new Error('db name is not set'));
        /* .pipe(catchError((err:DOMException)=>{
          if(err.name == 'VersionError')
                //self.indexedDB.deleteDatabase(p_name);
                //and/or reload the page
          return throwError(err);
        })) */
    }
    getTransaction(p_storeNames, p_mode) {
        return this.open()
            .pipe(map((idb) => {
            const tx = idb.transaction(p_storeNames, p_mode);
            return tx;
        }));
    }
    put(p_storeName, p_data, p_key) {
        return new Observable((observer) => {
            return this.getTransaction(p_storeName, 'readwrite').subscribe({
                next: (tx) => {
                    let req;
                    if (p_key) {
                        req = tx.objectStore(p_storeName).put(p_data, p_key);
                    }
                    else {
                        req = tx.objectStore(p_storeName).put(p_data);
                    }
                    req.onsuccess = () => {
                        observer.next(req.result);
                        observer.complete();
                    };
                    req.onerror = (err) => {
                        observer.error(err);
                    };
                }
            });
        });
    }
    onVersionChanged(p_db, p_changeEvent) {
        p_db.close();
        console.log("VersionChange. Please reload or close this tab!");
        alert('In einem anderen Fenster wird ein Update durchgeführt. Bitte diese Seite schließen.');
        location.reload();
    }
    onBlocked(p_db, p_ev) {
        console.log("db.Open()-Request  wurde geblockt. (Ist die App bereits woanders geöffnet?)");
        alert('DB konnte nicht aktualisiert werden. Bitte alle anderen Browserfenster schließen, und dieses Fenster neu laden!');
        location.reload();
    }
    onUpgradeNeeded(openDBRequest, ev) {
        console.log("upgrade needed for " + openDBRequest?.result?.name);
        if (ev.oldVersion == 0 && ev.newVersion >= 1)
            this.createDBScheme_1(openDBRequest);
    }
    createDBScheme_1(p_dbReq) {
        const idb = p_dbReq.result;
        //USER
        let store = idb.createObjectStore(this.USER, { keyPath: 'user' });
    }
    static { this.ɵfac = function LoginDBService_Factory(t) { return new (t || LoginDBService)(i0.ɵɵinject(OFFLINE_DB_NAME, 8)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginDBService, factory: LoginDBService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginDBService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [OFFLINE_DB_NAME]
            }] }]; }, null); })();

class LoginLibService {
    /**Die Anzahl der vom User registrierten Geräte */
    userDevicesCounter() {
        if (this.m_userDevicesCounter.value != null)
            return this.m_userDevicesCounter.asObservable();
        else
            return this.getUserDevices().pipe(switchMap(() => this.m_userDevicesCounter.asObservable()));
    }
    /** Gibt ein Objekt mit Daten des eingeloggten Users zurück */
    user() {
        const userObservable = () => {
            return this.m_user.asObservable().pipe(map((appUser) => {
                let user;
                if (appUser) {
                    user = {
                        user: appUser.user,
                        userFullName: appUser.userFullName,
                        userOid: appUser.userOid
                    };
                }
                return user;
            }));
        };
        if (this.m_user.getValue() != null)
            return userObservable();
        else
            return this.m_user.asObservable()
                .pipe(switchMap((res) => iif(() => res == null && this.LoggedInUser != undefined, this.getUser(), userObservable())));
    }
    constructor(loginService, userDeviceService, guidService, cookieService, storageService, m_baseHref, m_revision, m_dbNameBase, m_loginTranslations, offlineService, m_dialog) {
        this.loginService = loginService;
        this.userDeviceService = userDeviceService;
        this.guidService = guidService;
        this.cookieService = cookieService;
        this.storageService = storageService;
        this.m_baseHref = m_baseHref;
        this.m_revision = m_revision;
        this.m_dbNameBase = m_dbNameBase;
        this.m_loginTranslations = m_loginTranslations;
        this.offlineService = offlineService;
        this.m_dialog = m_dialog;
        this.FINGERPRINT = "Fingerprint";
        this.USER = "User";
        this.USER_OID = "UserOid";
        this.m_userDevicesCounter = new BehaviorSubject(null);
        this.m_user = new BehaviorSubject(null);
        if (this.m_loginTranslations) {
            this.m_loginIntl = this.m_loginTranslations;
        }
        else {
            this.m_loginIntl = new LoginIntl();
        }
        this.m_baseHref = this.m_baseHref.replace(/(\/(en|de)\/)/, '/');
        this.m_loggedInSubject = new BehaviorSubject(this.LoggedInUser != null);
        this.m_passwordResetSubject = new BehaviorSubject(false);
        this.passwordResetObservable = this.m_passwordResetSubject.asObservable();
        this.loggedInObservable = this.m_loggedInSubject.asObservable();
        window.addEventListener("storage", this.storageEventListener.bind(this));
    }
    /**
     * Eventlistener zur Feststellung von Änderungen am LoginUser (bspw. aus anderen Tabs)
     * @param event
     */
    storageEventListener(event) {
        if (!document.hasFocus() && event.storageArea == localStorage) {
            if (event.key == (this.m_baseHref + this.USER)) {
                if (!event.newValue) {
                    this.m_user.next(null);
                    this.m_loggedInSubject.next(false);
                }
                else if (!event.oldValue) {
                    location.reload();
                }
            }
        }
    }
    /**
     * liefert den Benutzernamen des angemeldeten Benutzers aus dem Storage zurück
     */
    get LoggedInUser() {
        return this.storageService.getItem('local', this.USER);
    }
    /**
     * liefert den aktuell gültigen Loginzustand zurück
     */
    get LoggedIn() {
        return this.m_loggedInSubject.getValue();
    }
    /**
     * ist kein Setter, da die Zugriffsoperatoren nicht übereinstimmen
     * @param p_userName
     */
    setLoggedInUser(p_userName) {
        //da mehrere Apps mit diesem Modul auf der gleichen Domain betrieben werden könnten, wird die baseHref zur Eindeutigkeit als Prefix verwendet
        this.storageService.setItem('local', this.USER, p_userName);
    }
    /**
     * Im Onlinezustand wird ein Serverseitiger Logout versucht.
     * Falls dieser fehlschlägt, erfolgreich ist oder im Offlinezustand erfolgt die clientseitige Abmeldung
     */
    logout() {
        return this.loginService.logout() // so oder so serverseitig ausloggen
            .pipe(tap(() => this.clientSideLogout()), catchError((err) => {
            this.clientSideLogout();
            return of(err);
        })); //tue dies bei Erfolg im Online- oder Offlinefall))
    }
    /**
     * ermöglicht das Provozieren eines RefreshLogins, da ohne UserIdCookie der Server die Session dann beendet
     */
    removeUserIdCookie() {
        this.cookieService.delete('userid', this.m_baseHref.substring(0, this.m_baseHref.lastIndexOf('/'))); //auf root
    }
    clientSideLogout() {
        if (this.m_dialog.openDialogs?.length > 0) {
            this.m_dialog.closeAll();
        }
        this.removeUserIdCookie();
        this.storageService.removeItem('local', this.USER);
        this.storageService.removeItem('local', this.USER_OID);
        this.m_user.next(null);
        this.m_loggedInSubject.next(false);
    }
    newPassword(p_newPassword, p_token) {
        return this.loginService.newPassword(p_newPassword, p_token).pipe(tap((res) => this.m_passwordResetSubject.next(true)));
    }
    /**
     * führt einen Login auf Basis der Offlinedaten durch
     * setzt bei Übereinstimmung den Offlinezustand
     * @param p_credentials
     */
    loginOffline(p_credentials) {
        const hashedPassword = CryptoES.SHA224(p_credentials.password).toString();
        return new Observable((os) => {
            if (this.m_dbNameBase) {
                return this.offlineService.getTransaction(this.USER, 'readonly')
                    .subscribe({
                    next: (tx) => {
                        let req = tx.objectStore(this.USER).get(p_credentials.user);
                        req.onsuccess = () => {
                            const appUser = req.result;
                            if (appUser) {
                                const samePass = appUser.password == hashedPassword;
                                const result = {
                                    retCode: samePass ? 0 : 1,
                                    msgCode: samePass ? 0 : 1,
                                    msgText: samePass ? '' : this.m_loginIntl.passwordIncorrect,
                                    secret: null,
                                    token: appUser.token ? appUser.token : null,
                                    QRCodeUrl: null,
                                    userOid: appUser.userOid,
                                    userFullName: appUser.loggedInUserName
                                };
                                if (samePass) {
                                    this.setLoggedInUser(appUser.user);
                                    this.m_user.next(appUser);
                                    this.m_loggedInSubject.next(true);
                                }
                                os.next(result);
                                os.complete();
                            }
                            else
                                os.error(new Error('no login found'));
                        };
                    }
                });
            }
            else {
                os.error(new Error('no offlineService or db name provided'));
            }
        });
    }
    /**
     * ermittelt die Client-ID (wird bei Bedarf geeneriert) und übermittelt diese mit den Zugangsdaten an den Server
     * Ber erfolgreicher Anmeldung erfolgt das Speichern des Users in den Offlineservice (falls verfügbar)
     * @param credentials
     */
    login(credentials) {
        return new Observable((os) => {
            let copiedCredentials = { ...credentials, revision: this.m_revision, version: 1 };
            let loginObservable = null;
            //wenn eine DB existiert, clientId aus dem User lesen
            if (this.m_dbNameBase) {
                loginObservable = new Observable((os2) => {
                    return this.offlineService.getTransaction(this.USER, 'readonly')
                        .subscribe({
                        next: (tx) => {
                            let req = tx.objectStore(this.USER).get(credentials.user);
                            req.onsuccess = () => {
                                let user = req.result;
                                copiedCredentials.clientId = user?.clientId;
                                os2.next(copiedCredentials);
                                os2.complete();
                            };
                        }
                    });
                });
            }
            else {
                //clientId aus dem Storage lesen
                let clientId = this.storageService.getItem('local', this.FINGERPRINT);
                if (clientId)
                    copiedCredentials.clientId = clientId;
                loginObservable = of(copiedCredentials);
            }
            loginObservable = loginObservable.pipe(switchMap((credentials) => {
                //es gab keine gespeicherte ClientId
                if (!credentials.clientId) {
                    credentials.clientId = this.guidService.newGuid();
                }
                return this.loginService.login(credentials);
            }));
            return loginObservable
                .pipe(switchMap((loginResult) => {
                let resultObservable = of(loginResult);
                //nach erfolgreichem Login muss, falls der Offlinedienst zur Verfügung steht, 
                //die DB für das LoginModul initialisiert und der User persistiert werden
                if (this.m_dbNameBase && loginResult && loginResult.retCode == 0) {
                    //diese routine einsparen?
                    resultObservable = new Observable((os2) => {
                        return this.offlineService.getTransaction(this.USER, 'readwrite')
                            .subscribe({
                            next: (tx) => {
                                if (copiedCredentials.password)
                                    copiedCredentials.password = CryptoES.SHA224(copiedCredentials.password).toString();
                                let user = {
                                    user: copiedCredentials.user,
                                    userOid: loginResult.userOid,
                                    token: loginResult.token,
                                    clientId: copiedCredentials.clientId,
                                    password: copiedCredentials.password,
                                    revision: copiedCredentials.revision,
                                    version: copiedCredentials.version,
                                    userFullName: loginResult.userFullName
                                };
                                let req = tx.objectStore(this.USER).put(user);
                                req.onsuccess = () => {
                                    this.m_user.next(user);
                                    os2.next(loginResult);
                                    os2.complete();
                                };
                            }
                        });
                    });
                    //die ursprüngliche LoginResponse zurückliefern
                }
                else {
                    //clientId speichern
                    this.storageService.setItem('local', this.FINGERPRINT, copiedCredentials.clientId);
                }
                return resultObservable;
            })).pipe(tap(res => {
                if (res && res.retCode == 0) {
                    this.setLoggedInUser(credentials.user);
                    this.m_loggedInSubject.next(true);
                }
            })).subscribe({
                next: (v) => os.next(v),
                complete: () => os.complete(),
                error: (e) => os.error(e),
            });
        });
    }
    refreshLogin() {
        return new Observable((os) => {
            return this.offlineService.getTransaction(this.USER, 'readonly')
                .subscribe({
                next: (tx) => {
                    let req = tx.objectStore(this.USER).get(this.LoggedInUser);
                    req.onsuccess = () => {
                        if (!req.result) {
                            os.error(new HttpErrorResponse({ error: 'Benutzer nicht gefunden', status: 401 }));
                        }
                        else if (!req.result.token)
                            os.error(new HttpErrorResponse({ error: 'Token-Login wird nicht unterstützt', status: 401 }));
                        else {
                            os.next(req.result);
                            os.complete();
                        }
                    };
                }
            });
        })
            .pipe(switchMap((user) => {
            return zip(of(user), this.loginService.login({
                clientId: user.clientId,
                password: undefined,
                user: user.user,
                revision: user.revision,
                version: user.version,
                token: user.token
            }));
        }))
            .pipe(switchMap(([user, response]) => {
            if (response && response.retCode == 0) {
                return new Observable((os2) => {
                    return this.offlineService.getTransaction(this.USER, 'readwrite')
                        .subscribe({
                        next: (tx) => {
                            //Anmeldung mit dem token erfolgreich
                            if (this.m_loggedInSubject.getValue() != true)
                                this.m_loggedInSubject.next(true);
                            let newUser = Object.assign(Object.assign({}, user), { revision: this.m_revision, userFullName: response.userFullName, token: response.token, userOid: response.userOid });
                            this.setLoggedInUser(newUser.user);
                            this.m_user.next(newUser);
                            let req = tx.objectStore(this.USER).put(newUser);
                            req.onsuccess = () => {
                                os2.next(response);
                                os2.complete();
                            };
                        }
                    });
                });
            }
            else {
                this.clientSideLogout();
                return throwError(new HttpErrorResponse({ status: 401, error: response.msgText }));
            }
        }));
    }
    /** Holt alle Geräte des Users vom Server*/
    getUserDevices() {
        return this.userDeviceService.getUserDevices()
            .pipe(tap((userDevices) => {
            this.m_userDevicesCounter.next(userDevices ? userDevices.length : 0);
            return userDevices;
        }));
    }
    /**
     * Holt den User aus der Datenbank.
     * Wird ein User gefunden, wird ein next
     * für das loggedInSubject ausgelöst.
     */
    getUser() {
        return new Observable((os) => {
            return this.offlineService.getTransaction(this.USER, 'readonly')
                .subscribe({
                next: (tx) => {
                    let req = tx.objectStore(this.USER).get(this.LoggedInUser);
                    req.onsuccess = () => {
                        //this.m_loggedInSubject.next(req.result ? true : false); sollte nur aufgerufen werden wenn sich abgemeldet oder angemeldet wird
                        this.m_user.next(req.result);
                        os.next(req.result);
                    };
                }
            });
        });
    }
    /** Entfernt ein Gerät vom Server */
    removeUserDevice(p_device) {
        return this.userDeviceService.removeUserDevice(p_device)
            .pipe(tap(() => {
            this.m_userDevicesCounter.next(this.m_userDevicesCounter.value - 1);
        }));
    }
    static { this.ɵfac = function LoginLibService_Factory(t) { return new (t || LoginLibService)(i0.ɵɵinject(LoginService), i0.ɵɵinject(UserDeviceService), i0.ɵɵinject(i3.GuidService), i0.ɵɵinject(i4.CookieService), i0.ɵɵinject(i3.StorageService), i0.ɵɵinject(APP_BASE_HREF), i0.ɵɵinject(REVISION, 8), i0.ɵɵinject(OFFLINE_DB_NAME, 8), i0.ɵɵinject(LoginIntl, 8), i0.ɵɵinject(LoginDBService), i0.ɵɵinject(i2.MatDialog)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginLibService, factory: LoginLibService.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LoginService }, { type: UserDeviceService }, { type: i3.GuidService }, { type: i4.CookieService }, { type: i3.StorageService }, { type: undefined, decorators: [{
                type: Inject,
                args: [APP_BASE_HREF]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [REVISION]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [OFFLINE_DB_NAME]
            }] }, { type: LoginIntl, decorators: [{
                type: Optional
            }] }, { type: LoginDBService }, { type: i2.MatDialog }]; }, null); })();

function ChangePasswordComponent_mat_error_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.m_changePasswordIntl.oldPasswordErrorRequired);
} }
function ChangePasswordComponent_mat_error_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.m_changePasswordIntl.oldPasswordErrorIncorrect);
} }
function ChangePasswordComponent_mat_error_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.m_changePasswordIntl.newPasswordErrorRequired);
} }
function ChangePasswordComponent_mat_error_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.m_changePasswordIntl.confirmPasswordErrorRequired);
} }
function ChangePasswordComponent_mat_error_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.m_changePasswordIntl.confirmPasswordErrorEqual);
} }
class ChangePasswordComponent {
    constructor(changePasswordIntl, m_formBuilder, m_loginService, m_loginLibService) {
        this.changePasswordIntl = changePasswordIntl;
        this.m_formBuilder = m_formBuilder;
        this.m_loginService = m_loginService;
        this.m_loginLibService = m_loginLibService;
        this.m_subscriptionsSubject = new Subject();
        this.m_messageHandlerClass = "info";
        this.OLD_PASSWORD = "oldPassword";
        this.NEW_PASSWORD = "newPassword";
        this.CONFIRM_PASSWORD = "confirmPassword";
        this.m_settingsPasswordForm = this.m_formBuilder.group({
            [this.OLD_PASSWORD]: ['', Validators.required],
            [this.NEW_PASSWORD]: ['', Validators.required],
            [this.CONFIRM_PASSWORD]: ['', [Validators.required, this.passwordMatcher.bind(this)]],
        });
        if (this.changePasswordIntl) {
            this.m_changePasswordIntl = this.changePasswordIntl;
        }
        else {
            this.m_changePasswordIntl = new ChangePasswordIntl();
            this.m_changePasswordIntl.titleText = 'Passwort ändern';
            this.m_changePasswordIntl.oldPasswordPlaceholder = 'altes Passwort';
            this.m_changePasswordIntl.oldPasswordErrorRequired = 'Pflichtfeld';
            this.m_changePasswordIntl.oldPasswordErrorIncorrect = 'Altes Passwort ist falsch';
            this.m_changePasswordIntl.newPasswordPlaceholder = 'neues Passwort';
            this.m_changePasswordIntl.newPasswordErrorRequired = 'Pflichtfeld';
            this.m_changePasswordIntl.confirmPasswordPlaceholder = 'neues Passwort (Wiederholung)';
            this.m_changePasswordIntl.confirmPasswordErrorRequired = 'Pflichtfeld';
            this.m_changePasswordIntl.confirmPasswordErrorEqual = 'Paswörter nicht identisch';
            this.m_changePasswordIntl.saveButtonText = 'Speichern';
            this.m_changePasswordIntl.resetButtonText = 'Zurücksetzen';
            this.m_changePasswordIntl.passwordChangeSuccessText = 'Passwort Änderung erfolgreich';
        }
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    passwordMatcher(p_control) {
        if (this.m_settingsPasswordForm && (p_control.value !== this.getControl(this.NEW_PASSWORD).value)) {
            return { notEqual: true };
        }
        else {
            return null;
        }
    }
    savePassword_Submit() {
        this.m_loginService.changePw(this.getControl(this.OLD_PASSWORD).value, this.getControl(this.NEW_PASSWORD).value).pipe(takeUntil(this.m_subscriptionsSubject)).pipe(switchMap(() => this.m_loginLibService.login({ user: this.m_loginLibService.LoggedInUser, password: this.getControl(this.NEW_PASSWORD).value, clientId: null }))).subscribe({
            next: (res) => {
                this.m_messageHandlerClass = "success";
                this.m_displayMessage = this.m_changePasswordIntl.passwordChangeSuccessText;
            },
            error: (err) => {
                this.m_messageHandlerClass = "danger";
                this.m_displayError = err;
            }
        });
    }
    getControl(p_name) {
        return this.m_settingsPasswordForm.get(p_name);
    }
    clearDisplayMessages() {
        this.m_displayError = null;
        this.m_displayMessage = null;
    }
    static { this.ɵfac = function ChangePasswordComponent_Factory(t) { return new (t || ChangePasswordComponent)(i0.ɵɵdirectiveInject(ChangePasswordIntl, 8), i0.ɵɵdirectiveInject(i4$1.UntypedFormBuilder), i0.ɵɵdirectiveInject(LoginService), i0.ɵɵdirectiveInject(LoginLibService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChangePasswordComponent, selectors: [["ebootis-change-password"]], decls: 36, vars: 19, consts: [["appearance", "outlined"], [1, "row"], [1, "col-12"], [3, "formGroup", "ngSubmit"], [1, "mat-headline-6"], ["appearance", "fill", 1, "w-100"], ["matInput", "", "type", "password", "autocomplete", "current-password", 3, "formControlName"], [4, "ngIf"], ["matInput", "", "type", "password", "autocomplete", "new-password", 3, "formControlName"], [1, "row", "mt-1"], ["mat-raised-button", "", "color", "primary", 3, "disabled"], [1, "row", "mt-3"], [3, "displayError", "displayMessage", "dismiss"]], template: function ChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card", 0)(1, "div", 1)(2, "div", 2)(3, "form", 3);
            i0.ɵɵlistener("ngSubmit", function ChangePasswordComponent_Template_form_ngSubmit_3_listener() { return ctx.savePassword_Submit(); });
            i0.ɵɵelementStart(4, "div", 1)(5, "div", 2)(6, "span", 4);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(8, "div", 1)(9, "div", 2)(10, "mat-form-field", 5)(11, "mat-label");
            i0.ɵɵtext(12);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(13, "input", 6);
            i0.ɵɵtemplate(14, ChangePasswordComponent_mat_error_14_Template, 2, 1, "mat-error", 7);
            i0.ɵɵtemplate(15, ChangePasswordComponent_mat_error_15_Template, 2, 1, "mat-error", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(16, "div", 2)(17, "mat-form-field", 5)(18, "mat-label");
            i0.ɵɵtext(19);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(20, "input", 8);
            i0.ɵɵtemplate(21, ChangePasswordComponent_mat_error_21_Template, 2, 1, "mat-error", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(22, "div", 2)(23, "mat-form-field", 5)(24, "mat-label");
            i0.ɵɵtext(25);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(26, "input", 8);
            i0.ɵɵtemplate(27, ChangePasswordComponent_mat_error_27_Template, 2, 1, "mat-error", 7);
            i0.ɵɵtemplate(28, ChangePasswordComponent_mat_error_28_Template, 2, 1, "mat-error", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(29, "div", 9)(30, "div", 2)(31, "button", 10);
            i0.ɵɵtext(32);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(33, "div", 11)(34, "div", 2)(35, "ebootis-message-handler", 12);
            i0.ɵɵlistener("dismiss", function ChangePasswordComponent_Template_ebootis_message_handler_dismiss_35_listener() { return ctx.clearDisplayMessages(); });
            i0.ɵɵelementEnd()()()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.m_settingsPasswordForm);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_changePasswordIntl.titleText);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_changePasswordIntl.oldPasswordPlaceholder);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.OLD_PASSWORD);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.OLD_PASSWORD).hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.OLD_PASSWORD).hasError("oldPwIncorrect"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_changePasswordIntl.newPasswordPlaceholder);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.NEW_PASSWORD);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.NEW_PASSWORD).hasError("required"));
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_changePasswordIntl.confirmPasswordPlaceholder);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.CONFIRM_PASSWORD);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.CONFIRM_PASSWORD).hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.CONFIRM_PASSWORD).hasError("notEqual"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", !ctx.m_settingsPasswordForm.valid);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(ctx.m_changePasswordIntl.saveButtonText);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.m_messageHandlerClass);
            i0.ɵɵproperty("displayError", ctx.m_displayError)("displayMessage", ctx.m_displayMessage);
        } }, dependencies: [i4$1.ɵNgNoValidate, i4$1.DefaultValueAccessor, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i5.NgIf, i6.MatFormField, i6.MatLabel, i6.MatError, i10.MatCard, i3$1.MatButton, i9.MatInput, i3.MessageHandlerComponent] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangePasswordComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-change-password', template: "\n<mat-card appearance=\"outlined\">\n    \n    <div class=\"row\">\n        <div class=\"col-12\">\n            <form [formGroup]=\"m_settingsPasswordForm\" (ngSubmit)=\"savePassword_Submit()\">\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <span class=\"mat-headline-6\">{{m_changePasswordIntl.titleText}}</span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\">\n                            <mat-label>{{m_changePasswordIntl.oldPasswordPlaceholder}}</mat-label>\n                            <input matInput type=\"password\" autocomplete=\"current-password\" [formControlName]=\"OLD_PASSWORD\">\n                            <mat-error *ngIf=\"getControl(OLD_PASSWORD).hasError('required')\">{{m_changePasswordIntl.oldPasswordErrorRequired}}</mat-error>\n                            <mat-error *ngIf=\"getControl(OLD_PASSWORD).hasError('oldPwIncorrect')\">{{m_changePasswordIntl.oldPasswordErrorIncorrect}}</mat-error>\n                        </mat-form-field>\n                    </div>\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\">\n                            <mat-label>{{m_changePasswordIntl.newPasswordPlaceholder}}</mat-label>\n                            <input matInput type=\"password\" autocomplete=\"new-password\" [formControlName]=\"NEW_PASSWORD\">\n                            <mat-error *ngIf=\"getControl(NEW_PASSWORD).hasError('required')\">{{m_changePasswordIntl.newPasswordErrorRequired}}</mat-error>\n                        </mat-form-field>\n                    </div>\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\">\n                            <mat-label>{{m_changePasswordIntl.confirmPasswordPlaceholder}}</mat-label>\n                            <input matInput type=\"password\" autocomplete=\"new-password\" [formControlName]=\"CONFIRM_PASSWORD\">\n                            <mat-error *ngIf=\"getControl(CONFIRM_PASSWORD).hasError('required')\">{{m_changePasswordIntl.confirmPasswordErrorRequired}}</mat-error>\n                            <mat-error *ngIf=\"getControl(CONFIRM_PASSWORD).hasError('notEqual')\">{{m_changePasswordIntl.confirmPasswordErrorEqual}}</mat-error>\n                        </mat-form-field>\n                    </div>\n                </div>\n                <div class=\"row mt-1\">\n                    <div class=\"col-12\">\n                        <button mat-raised-button color=\"primary\" [disabled]=\"!m_settingsPasswordForm.valid\">{{m_changePasswordIntl.saveButtonText}}</button>\n                    </div>\n                </div>\n                <div class=\"row mt-3\">\n                    <div class=\"col-12\">\n                        <ebootis-message-handler (dismiss)=\"clearDisplayMessages()\" [displayError]=\"m_displayError\" [displayMessage]=\"m_displayMessage\" [class]=\"m_messageHandlerClass\"></ebootis-message-handler>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</mat-card>" }]
    }], function () { return [{ type: ChangePasswordIntl, decorators: [{
                type: Optional
            }] }, { type: i4$1.UntypedFormBuilder }, { type: LoginService }, { type: LoginLibService }]; }, null); })();

class ResetPasswordDialogIntl {
    constructor() {
        this.changes = new Subject();
    }
    static { this.ɵfac = function ResetPasswordDialogIntl_Factory(t) { return new (t || ResetPasswordDialogIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ResetPasswordDialogIntl, factory: ResetPasswordDialogIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordDialogIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ResetPasswordDialog {
    constructor(resetPwDialogIntl, m_dialogRef) {
        this.resetPwDialogIntl = resetPwDialogIntl;
        this.m_dialogRef = m_dialogRef;
        if (this.resetPwDialogIntl) {
            this.m_resetPwDialogIntl = this.resetPwDialogIntl;
        }
        else {
            this.m_resetPwDialogIntl = new ResetPasswordDialogIntl();
            this.m_resetPwDialogIntl.titleText = 'Zurücksetzen';
            this.m_resetPwDialogIntl.dialogText = 'Möchten Sie Ihr Passwort wirklich zurücksetzen?';
            this.m_resetPwDialogIntl.yesButtonText = 'Ja';
            this.m_resetPwDialogIntl.noButtonText = 'Nein';
        }
    }
    no_Click() {
        this.m_dialogRef.close(false);
    }
    yes_Click() {
        this.m_dialogRef.close(true);
    }
    static { this.ɵfac = function ResetPasswordDialog_Factory(t) { return new (t || ResetPasswordDialog)(i0.ɵɵdirectiveInject(ResetPasswordDialogIntl, 8), i0.ɵɵdirectiveInject(i2.MatDialogRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ResetPasswordDialog, selectors: [["reset-pw-dialog"]], decls: 10, vars: 4, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-dialog-content", ""], ["mat-dialog-actions", ""], ["mat-button", "", 3, "click"], ["mat-raised-button", "", "color", "primary", "cdkFocusInitial", "", 3, "click"]], template: function ResetPasswordDialog_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3)(6, "button", 4);
            i0.ɵɵlistener("click", function ResetPasswordDialog_Template_button_click_6_listener() { return ctx.yes_Click(); });
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "button", 5);
            i0.ɵɵlistener("click", function ResetPasswordDialog_Template_button_click_8_listener() { return ctx.no_Click(); });
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_resetPwDialogIntl.titleText, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_resetPwDialogIntl.dialogText, "\n");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_resetPwDialogIntl.yesButtonText);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.m_resetPwDialogIntl.noButtonText);
        } }, dependencies: [i2.MatDialogTitle, i2.MatDialogContent, i2.MatDialogActions, i3$1.MatButton], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordDialog, [{
        type: Component,
        args: [{ selector: 'reset-pw-dialog', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\r\n    <span class=\"ebo-dialog-title\">\r\n        {{m_resetPwDialogIntl.titleText}}\r\n    </span>\r\n</h1>\r\n<div mat-dialog-content>\r\n    {{m_resetPwDialogIntl.dialogText}}\r\n</div>\r\n<div mat-dialog-actions>\r\n    <button mat-button (click)=\"yes_Click()\">{{m_resetPwDialogIntl.yesButtonText}}</button>\r\n    <button mat-raised-button color=\"primary\" cdkFocusInitial (click)=\"no_Click()\">{{m_resetPwDialogIntl.noButtonText}}</button>\r\n</div>" }]
    }], function () { return [{ type: ResetPasswordDialogIntl, decorators: [{
                type: Optional
            }] }, { type: i2.MatDialogRef }]; }, null); })();

class TryOfflineDialog {
    constructor(loginIntl, m_dialogRef) {
        this.loginIntl = loginIntl;
        this.m_dialogRef = m_dialogRef;
        if (this.loginIntl) {
            this.m_loginIntl = this.loginIntl;
        }
        else {
            this.m_loginIntl = new LoginIntl();
        }
    }
    tryOffline_Closed(p_try) {
        this.m_dialogRef.close(p_try);
    }
    static { this.ɵfac = function TryOfflineDialog_Factory(t) { return new (t || TryOfflineDialog)(i0.ɵɵdirectiveInject(LoginIntl, 8), i0.ɵɵdirectiveInject(i2.MatDialogRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: TryOfflineDialog, selectors: [["try-offline-dialog"]], decls: 11, vars: 4, consts: [["mat-dialog-title", "", 1, "ebo-dialog-header"], [1, "ebo-dialog-title"], ["mat-dialog-content", ""], ["mat-dialog-actions", "", 1, "ebo-dialog-actions"], ["mat-button", "", 3, "click"], ["mat-button", "", "cdkFocusInitial", "", 3, "click"]], template: function TryOfflineDialog_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "h1", 0)(1, "span", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 2)(4, "p");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 3)(7, "button", 4);
            i0.ɵɵlistener("click", function TryOfflineDialog_Template_button_click_7_listener() { return ctx.tryOffline_Closed(false); });
            i0.ɵɵtext(8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "button", 5);
            i0.ɵɵlistener("click", function TryOfflineDialog_Template_button_click_9_listener() { return ctx.tryOffline_Closed(true); });
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.m_loginIntl.tryOfflineTitle, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_loginIntl.tryOfflineText);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_loginIntl.buttonCancel);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.m_loginIntl.buttonOk);
        } }, dependencies: [i2.MatDialogTitle, i2.MatDialogContent, i2.MatDialogActions, i3$1.MatButton], encapsulation: 2 }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TryOfflineDialog, [{
        type: Component,
        args: [{ selector: 'try-offline-dialog', template: "<h1 mat-dialog-title class=\"ebo-dialog-header\">\r\n  <span class=\"ebo-dialog-title\">\r\n    {{m_loginIntl.tryOfflineTitle}}\r\n  </span>\r\n</h1>\r\n<div mat-dialog-content>\r\n  <p>{{m_loginIntl.tryOfflineText}}</p>\r\n</div>\r\n<div mat-dialog-actions class=\"ebo-dialog-actions\">\r\n  <button mat-button (click)=\"tryOffline_Closed(false)\">{{m_loginIntl.buttonCancel}}</button>\r\n  <button mat-button (click)=\"tryOffline_Closed(true)\" cdkFocusInitial>{{m_loginIntl.buttonOk}}</button>\r\n</div>" }]
    }], function () { return [{ type: LoginIntl, decorators: [{
                type: Optional
            }] }, { type: i2.MatDialogRef }]; }, null); })();

/**
 * Diese Klasse wird zur Konfiguration verschiedener Login Einstellungen verwendet
 * Sie kann abgeleitet werden, um appspezifisch Einstellungen zu konfigurieren
 */
class LoginConfig {
    constructor() { }
    /**
     * gibt an, ob nach einem fehlerhaften Online-Login der Dialog zur Offlineanmeldung angezeigt werden soll oder die Offline Anmeldung automatisch erfolgen soll
     * Wenn true, und Passwort liegt im Hash vor, dann wird der Offlinelogin automatisch durchgeführt
     * Wenn false, wird der Dialog zur Rückfrage an den Benutzer zum Offline Login geöffnet
     */
    autoLoginOffline() {
        return false;
    }
    static { this.ɵfac = function LoginConfig_Factory(t) { return new (t || LoginConfig)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: LoginConfig, factory: LoginConfig.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["formDirective"];
function LoginComponent_div_7_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", ctx_r8.m_loginIntl.userErrorRequired, " ");
} }
function LoginComponent_div_7_mat_error_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.m_loginIntl.passwordErrorRequired, "");
} }
function LoginComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 12)(2, "div", 5)(3, "mat-form-field", 13)(4, "mat-label");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 14);
    i0.ɵɵtemplate(7, LoginComponent_div_7_mat_error_7_Template, 2, 1, "mat-error", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 16)(9, "div", 5)(10, "mat-form-field", 13)(11, "mat-label");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 17);
    i0.ɵɵtemplate(14, LoginComponent_div_7_mat_error_14_Template, 2, 1, "mat-error", 18);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.m_loginIntl.userPlaceholder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r1.USER);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.getControl(ctx_r1.USER).hasError("required"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.m_loginIntl.passwordPlaceholder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r1.PASSWORD);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.getControl(ctx_r1.PASSWORD).hasError("required"));
} }
function LoginComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 16)(2, "div", 5)(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelement(6, "img", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 27)(8, "div", 5)(9, "p")(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span")(13, "b");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r10.m_loginIntl.qrcodeDescriptionText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r10.m_qrCodeUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r10.m_loginIntl.secretDescriptionText);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r10.m_qrSecret);
} }
function LoginComponent_ng_template_8_mat_error_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.m_loginIntl.authcodeErrorRequired, "");
} }
function LoginComponent_ng_template_8_mat_error_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.m_loginIntl.authcodeErrorMinlength, "");
} }
function LoginComponent_ng_template_8_mat_form_field_16_mat_error_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.m_loginIntl.deviceNameErrorRequired, "");
} }
function LoginComponent_ng_template_8_mat_form_field_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 13)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 28);
    i0.ɵɵtemplate(4, LoginComponent_ng_template_8_mat_form_field_16_mat_error_4_Template, 2, 1, "mat-error", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r14.m_loginIntl.deviceNamePlaceholder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r14.DEVICE_NAME);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r14.getControl(ctx_r14.DEVICE_NAME).touched && ctx_r14.getControl(ctx_r14.DEVICE_NAME).hasError("required"));
} }
function LoginComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, LoginComponent_ng_template_8_div_0_Template, 15, 4, "div", 15);
    i0.ɵɵelementStart(1, "div", 16)(2, "div", 5)(3, "mat-form-field", 13)(4, "mat-label");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 20, 21);
    i0.ɵɵtemplate(8, LoginComponent_ng_template_8_mat_error_8_Template, 2, 1, "mat-error", 15);
    i0.ɵɵtemplate(9, LoginComponent_ng_template_8_mat_error_9_Template, 2, 1, "mat-error", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div", 22)(11, "div", 5)(12, "mat-checkbox", 23);
    i0.ɵɵlistener("change", function LoginComponent_ng_template_8_Template_mat_checkbox_change_12_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r16.makeDeviceNameReq_Change($event.checked)); });
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 16)(15, "div", 5);
    i0.ɵɵtemplate(16, LoginComponent_ng_template_8_mat_form_field_16_Template, 5, 3, "mat-form-field", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.m_qrCodeUrl);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r3.m_loginIntl.authcodePlaceholder);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r3.TOTP);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.getControl(ctx_r3.TOTP).touched && ctx_r3.getControl(ctx_r3.TOTP).hasError("required"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.getControl(ctx_r3.TOTP).touched && ctx_r3.getControl(ctx_r3.TOTP).hasError("minlength"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("formControlName", ctx_r3.TRUSTED_DEVICE);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.m_loginIntl.trustedDeviceText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.getControl(ctx_r3.TRUSTED_DEVICE).value);
} }
function LoginComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function LoginComponent_button_12_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r18.goBack()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.m_loginIntl.buttonCancel);
} }
function LoginComponent_mat_spinner_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-spinner", 30);
} if (rf & 2) {
    i0.ɵɵproperty("diameter", 20);
} }
function LoginComponent_button_16_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function LoginComponent_button_16_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r20.openDialog_Click()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", !ctx_r6.getControl(ctx_r6.USER).valid || ctx_r6.m_loading);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.m_loginIntl.passwortResetButtonText);
} }
function LoginComponent_ng_template_20_Template(rf, ctx) { }
const RESET_PASSWORD_ROUTE = new InjectionToken('short URL for password reset request');
class LoginComponent {
    constructor(m_resetPasswordRoute, loginIntl, m_loginService, m_loginLibService, m_formBuilder, m_dialog, loginConfig, dbName, offlineService) {
        this.m_resetPasswordRoute = m_resetPasswordRoute;
        this.loginIntl = loginIntl;
        this.m_loginService = m_loginService;
        this.m_loginLibService = m_loginLibService;
        this.m_formBuilder = m_formBuilder;
        this.m_dialog = m_dialog;
        this.loginConfig = loginConfig;
        this.dbName = dbName;
        this.offlineService = offlineService;
        this.loggedIn = new EventEmitter();
        this.RESET_2FA = 'reset2FA';
        this.SEND_2FA_SCRATCH_CODE = 'send2FAScratchCode';
        this.DEVICE_NAME = 'deviceName';
        this.TOTP = 'TOTP';
        this.USER = 'user';
        this.INFO = 'info';
        this.DANGER = 'danger';
        this.SUCCESS = 'success';
        this.TRUSTED_DEVICE = "trustedDevice";
        this.PASSWORD = "password";
        this.m_subscriptionsSubject = new Subject();
        this.m_messageHandlerClass = "info";
        this.m_showTOTP = false;
        this.m_qrCodeUrl = '';
        this.m_qrSecret = '';
        this.m_loading = false;
        if (this.loginIntl) {
            this.m_loginIntl = this.loginIntl;
        }
        else {
            this.m_loginIntl = new LoginIntl();
        }
    }
    ngOnInit() {
        this.initLoginForm();
    }
    initLoginForm() {
        this.m_loginForm = this.m_formBuilder.group({
            [this.USER]: ['', Validators.required],
            [this.PASSWORD]: ['', Validators.required],
            [this.TOTP]: [''],
            [this.TRUSTED_DEVICE]: [false],
            [this.DEVICE_NAME]: [''],
            [this.RESET_2FA]: [false],
            [this.SEND_2FA_SCRATCH_CODE]: [false]
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    reset2FA_Click() {
        this.getControl(this.RESET_2FA).setValue(true);
        this.login().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (res) => {
                this.getControl(this.TOTP).clearValidators();
                this.getControl(this.DEVICE_NAME).clearValidators();
                this.formDirective.resetForm();
                this.m_loginForm.reset();
                this.m_showTOTP = false;
            }
        });
    }
    send2FAScratchCode_Click() {
        this.getControl(this.SEND_2FA_SCRATCH_CODE).setValue(true);
        this.login().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (res) => {
                this.getControl(this.SEND_2FA_SCRATCH_CODE).setValue(false);
            }
        });
    }
    login_Submit() {
        this.login().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe();
    }
    login() {
        this.m_loading = true;
        this.clearDisplayMessages();
        let credentials = this.m_loginForm.value;
        this.offlineService?.setState(false);
        return this.m_loginLibService.login(credentials)
            .pipe(finalize(() => this.m_loading = false))
            .pipe(catchError((err, caught) => this.handleError(err, credentials)))
            //falls login einen fehler verursacht, werden diese in handleError verarbeitet()
            //handle Error kann ein loginOffline Aufruf zurückliefern 
            .pipe(switchMap((data) => this.checkLogin(data)))
            .pipe(tap((success) => {
            this.loggedIn.emit(success);
        }, error => {
            this.m_messageHandlerClass = this.DANGER;
            this.m_displayError = error;
        }));
        /*.pipe(tap(
  
      ));*/
    }
    /**
     * fängt einen Observable-Fehler ab und prüft, ob keine Internetverbindung besteht.
     * Falls das der Fall ist, wird dem Benutzer ein Offline-Login vorgeschlagen
     * und bei Bestätigung ausgeführt.
     * Liefert einen Observable der entweder den Fehler weiterreicht, oder loginOffline ausführt
     *
     * @param p_err der aufgetretene Fehler
     * @param p_credentials die Benutzereingaben
     */
    handleError(p_err, p_credentials) {
        //Falls keine Netzwerkverbindung besteht
        //UND der OfflineService zur Verfügung steht
        if (!p_err.ok && (p_err.status == 0 || p_err.status == 504 || p_err.status == 503 || p_err.status == 502 || p_err.name == 'TimeoutError') && this.dbName) {
            if (this.loginConfig.autoLoginOffline())
                return this.loginOffline(p_credentials);
            else
                return this.m_dialog.open(TryOfflineDialog).afterClosed().pipe(switchMap((answer) => {
                    if (answer) { //ja, offline versuchen:
                        return this.loginOffline(p_credentials);
                    }
                    else
                        return throwError(p_err);
                }));
        }
        else
            return throwError(p_err);
    }
    loginOffline(p_credentials) {
        return this.m_loginLibService.loginOffline(p_credentials)
            .pipe(tap(() => this.offlineService?.setState(true)));
    }
    makeDeviceNameReq_Change(p_markAsRequired) {
        this.getControl(this.DEVICE_NAME).setValidators(p_markAsRequired ? [Validators.required] : null);
        this.formDirective.resetForm(this.m_loginForm.value);
    }
    /**
     * prüft die Codes(ReturnCode, MsgCode) in der Serverantwort
     * und führt die erforderliche Aktion
     * (2FA Einrichtung,Gerätregistrierung,Code Eingabe) aus
     *
     * @param p_loginResponse
     */
    checkLogin(p_loginResponse) {
        return new Observable((observer) => {
            //this.checkLoginMsg(p_loginResponse.msgCode, p_loginResponse.msgText);
            if (p_loginResponse.msgCode && p_loginResponse.msgText) {
                switch (p_loginResponse.msgCode) {
                    case 1:
                    case 4: {
                        this.m_messageHandlerClass = this.DANGER;
                        this.m_displayMessage = p_loginResponse.msgText;
                        break;
                    }
                    case 8:
                    case 9: {
                        this.m_messageHandlerClass = this.SUCCESS;
                        this.m_displayMessage = p_loginResponse.msgText;
                        break;
                    }
                }
            }
            switch (p_loginResponse.retCode) {
                // Login erfolgreich
                /*case 0: {
                  break;
                }*/
                // Login mit Einmalpasswort (z.B. Google Authenticator)
                case 3: {
                    this.m_qrCodeUrl = p_loginResponse.QRCodeUrl;
                    this.m_qrSecret = p_loginResponse.secret;
                    this.m_showTOTP = true;
                    this.getControl(this.TOTP).setValidators([Validators.required, Validators.minLength(6)]);
                    this.formDirective.resetForm(this.m_loginForm.value);
                }
            }
            observer.next(p_loginResponse.retCode == 0);
            observer.complete();
        });
    }
    /**
     * Öffnet das Dialogfenster zum Zurücksetzen des Passworts
     * Nach Bestätigung wird die Servicemethode aufgerufen, und dieser der User und die Angular Route mitgeliefert
     */
    openDialog_Click() {
        const dialogRef = this.m_dialog.open(ResetPasswordDialog, {});
        dialogRef.afterClosed().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (result) => {
                if (result == true) {
                    this.m_loginService.resetPassword(this.getControl(this.USER).value, this.m_resetPasswordRoute).pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
                        next: (res) => {
                            this.m_messageHandlerClass = this.SUCCESS;
                            this.m_displayMessage = res.msgText;
                        },
                        error: (error) => {
                            this.m_messageHandlerClass = this.DANGER;
                            this.m_displayError = error;
                        }
                    });
                }
            }
        });
    }
    getControl(p_name) {
        return this.m_loginForm.get(p_name);
    }
    clearDisplayMessages() {
        this.m_displayError = null;
        this.m_displayMessage = null;
    }
    goBack() {
        this.m_showTOTP = false;
        this.initLoginForm();
    }
    static { this.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(i0.ɵɵdirectiveInject(RESET_PASSWORD_ROUTE, 8), i0.ɵɵdirectiveInject(LoginIntl, 8), i0.ɵɵdirectiveInject(LoginService), i0.ɵɵdirectiveInject(LoginLibService), i0.ɵɵdirectiveInject(i4$1.FormBuilder), i0.ɵɵdirectiveInject(i2.MatDialog), i0.ɵɵdirectiveInject(LoginConfig), i0.ɵɵdirectiveInject(OFFLINE_DB_NAME, 8), i0.ɵɵdirectiveInject(i3.OnlineOfflineService, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["ebootis-login"]], viewQuery: function LoginComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.formDirective = _t.first);
        } }, outputs: { loggedIn: "loggedIn" }, decls: 21, vars: 13, consts: [[3, "formGroup", "ngSubmit"], ["formDirective", "ngForm"], [4, "ngIf", "ngIfElse"], ["TOTPUI", ""], [1, "row", "mt-2", "mb-3"], [1, "col-12"], ["mat-raised-button", "", "type", "button", "class", "me-3", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", 1, "inline-spinner", 3, "disabled"], [3, "diameter", 4, "ngIf"], ["mat-button", "", "type", "button", "class", "float-end", "color", "primary", 3, "disabled", "click", 4, "ngIf"], [1, "row", "mt-3"], [3, "displayError", "displayMessage", "dismiss"], [1, "row", "pb-3"], ["appearance", "fill", 1, "w-100"], ["matInput", "", "autocomplete", "username", "autocapitalize", "off", 3, "formControlName"], [4, "ngIf"], [1, "row"], ["matInput", "", "type", "password", "autocomplete", "current-password", 3, "formControlName"], ["translate", "", 4, "ngIf"], ["translate", ""], ["matInput", "", "type", "text", "inputmode", "numeric", "pattern", "[0-9]*", "autocomplete", "one-time-code", 3, "formControlName"], ["totp", ""], [1, "row", "auth-checkbox"], ["color", "primary", 3, "formControlName", "change"], ["class", "w-100", "appearance", "fill", 4, "ngIf"], [1, "row", "justify-content-center"], ["alt", "QRCode for Login", 3, "src"], [1, "row", "mt-2"], ["matInput", "", "autocomplete", "off", 3, "formControlName"], ["mat-raised-button", "", "type", "button", 1, "me-3", 3, "click"], [3, "diameter"], ["mat-button", "", "type", "button", "color", "primary", 1, "float-end", 3, "disabled", "click"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card")(1, "mat-card-header")(2, "mat-card-title");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(4, "mat-card-content")(5, "form", 0, 1);
            i0.ɵɵlistener("ngSubmit", function LoginComponent_Template_form_ngSubmit_5_listener() { return ctx.login_Submit(); });
            i0.ɵɵtemplate(7, LoginComponent_div_7_Template, 15, 6, "div", 2);
            i0.ɵɵtemplate(8, LoginComponent_ng_template_8_Template, 17, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(10, "div", 4)(11, "div", 5);
            i0.ɵɵtemplate(12, LoginComponent_button_12_Template, 2, 1, "button", 6);
            i0.ɵɵelementStart(13, "button", 7);
            i0.ɵɵtemplate(14, LoginComponent_mat_spinner_14_Template, 1, 1, "mat-spinner", 8);
            i0.ɵɵtext(15);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, LoginComponent_button_16_Template, 2, 2, "button", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "div", 10)(18, "div", 5)(19, "ebootis-message-handler", 11);
            i0.ɵɵlistener("dismiss", function LoginComponent_Template_ebootis_message_handler_dismiss_19_listener() { return ctx.clearDisplayMessages(); });
            i0.ɵɵelementEnd()()()()()();
            i0.ɵɵtemplate(20, LoginComponent_ng_template_20_Template, 0, 0, "ng-template");
        } if (rf & 2) {
            const _r2 = i0.ɵɵreference(9);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.m_loginIntl.titleText);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.m_loginForm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.m_showTOTP)("ngIfElse", _r2);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.m_showTOTP);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", !ctx.m_loginForm.valid || ctx.m_loading);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.m_loading);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1(" ", ctx.m_loginIntl.loginButtonText, " ");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.m_showTOTP && ctx.m_resetPasswordRoute);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.m_messageHandlerClass);
            i0.ɵɵproperty("displayError", ctx.m_displayError)("displayMessage", ctx.m_displayMessage);
        } }, dependencies: [i4$1.ɵNgNoValidate, i4$1.DefaultValueAccessor, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.PatternValidator, i4$1.FormGroupDirective, i4$1.FormControlName, i5.NgIf, i6.MatFormField, i6.MatLabel, i6.MatError, i10.MatCard, i10.MatCardContent, i10.MatCardHeader, i10.MatCardTitle, i3$1.MatButton, i9.MatInput, i13.MatCheckbox, i3.MessageHandlerComponent, i14.MatProgressSpinner], styles: [".w-100[_ngcontent-%COMP%]{width:100%}.inline-spinner[_ngcontent-%COMP%], .inline-spinner[_ngcontent-%COMP%] > .mdc-button__label[_ngcontent-%COMP%]{display:inline-flex;flex:0;flex-wrap:nowrap}.inline-spinner[_ngcontent-%COMP%]   .mat-mdc-progress-spinner[_ngcontent-%COMP%], .inline-spinner[_ngcontent-%COMP%] > .mdc-button__label[_ngcontent-%COMP%]   .mat-mdc-progress-spinner[_ngcontent-%COMP%]{display:inline-block!important}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-login', template: "<mat-card>\n    <mat-card-header>\n          <mat-card-title>{{m_loginIntl.titleText}}</mat-card-title>\n    </mat-card-header>\n    <mat-card-content>\n        <form [formGroup]=\"m_loginForm\" #formDirective=\"ngForm\" (ngSubmit)=\"login_Submit()\">\n            <div *ngIf=\"!m_showTOTP; else TOTPUI\">\n                <div class=\"row pb-3\">\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\">\n                            <mat-label>{{m_loginIntl.userPlaceholder}}</mat-label>\n                            <input matInput [formControlName]=\"USER\" autocomplete=\"username\" autocapitalize=\"off\">\n                            <mat-error *ngIf=\"getControl(USER).hasError('required')\">{{m_loginIntl.userErrorRequired}}\n                            </mat-error>\n                        </mat-form-field>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\">\n                            <mat-label>{{m_loginIntl.passwordPlaceholder}}</mat-label>\n                            <input matInput type=\"password\" [formControlName]=\"PASSWORD\"\n                                autocomplete=\"current-password\">\n                            <mat-error *ngIf=\"getControl(PASSWORD).hasError('required')\" translate>\n                                {{m_loginIntl.passwordErrorRequired}}</mat-error>\n                        </mat-form-field>\n                    </div>\n                </div>\n            </div>\n            <ng-template #TOTPUI>\n                <div *ngIf=\"m_qrCodeUrl\">\n                    <div class=\"row\">\n                        <div class=\"col-12\">\n                            <p>{{m_loginIntl.qrcodeDescriptionText}}</p>\n                        </div>\n                    </div>\n                    <div class=\"row justify-content-center\">\n                        <img [src]=\"m_qrCodeUrl\" alt=\"QRCode for Login\" />\n                    </div>\n                    <div class=\"row mt-2\">\n                        <div class=\"col-12\">\n                            <p><span>{{m_loginIntl.secretDescriptionText}}</span><span><b>{{m_qrSecret}}</b></span></p>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\">\n                            <mat-label>{{m_loginIntl.authcodePlaceholder}}</mat-label>\n                            <input matInput type=\"text\" inputmode=\"numeric\" pattern=\"[0-9]*\"\n                                autocomplete=\"one-time-code\" #totp [formControlName]=\"TOTP\">\n                            <mat-error *ngIf=\"getControl(TOTP).touched && getControl(TOTP).hasError('required')\">\n                                {{m_loginIntl.authcodeErrorRequired}}</mat-error>\n                            <mat-error *ngIf=\"getControl(TOTP).touched && getControl(TOTP).hasError('minlength')\">\n                                {{m_loginIntl.authcodeErrorMinlength}}</mat-error>\n                        </mat-form-field>\n                    </div>\n                </div>\n                <div class=\"row auth-checkbox\">\n                    <div class=\"col-12\">\n                        <mat-checkbox color=\"primary\" (change)=\"makeDeviceNameReq_Change($event.checked)\"\n                            [formControlName]=\"TRUSTED_DEVICE\">{{m_loginIntl.trustedDeviceText}}</mat-checkbox>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-12\">\n                        <mat-form-field class=\"w-100\" appearance=\"fill\" *ngIf=\"getControl(TRUSTED_DEVICE).value\">\n                            <mat-label>{{m_loginIntl.deviceNamePlaceholder}}</mat-label>\n                            <input matInput autocomplete=\"off\" [formControlName]=\"DEVICE_NAME\">\n                            <mat-error\n                                *ngIf=\"getControl(DEVICE_NAME).touched && getControl(DEVICE_NAME).hasError('required')\">\n                                {{m_loginIntl.deviceNameErrorRequired}}</mat-error>\n                        </mat-form-field>\n                    </div>\n                </div>\n            </ng-template>\n            <div class=\"row mt-2 mb-3\">\n                <div class=\"col-12\">\n                    <button mat-raised-button type=\"button\" *ngIf=\"m_showTOTP\" (click)=\"goBack()\"\n                        class=\"me-3\">{{m_loginIntl.buttonCancel}}</button>\n                    <button mat-raised-button color=\"primary\" class=\"inline-spinner\"\n                        [disabled]=\"!m_loginForm.valid||m_loading\">\n                        <mat-spinner *ngIf=\"m_loading\" [diameter]=\"20\"></mat-spinner> {{m_loginIntl.loginButtonText}}\n                    </button>\n                    <button mat-button type=\"button\" class=\"float-end\" color=\"primary\"\n                        *ngIf=\"!m_showTOTP && m_resetPasswordRoute\" [disabled]=\"!getControl(USER).valid||m_loading\"\n                        (click)=\"openDialog_Click()\">{{m_loginIntl.passwortResetButtonText}}</button>\n\n                </div>\n            </div>\n            <div class=\"row mt-3\">\n                <div class=\"col-12\">\n                    <ebootis-message-handler (dismiss)=\"clearDisplayMessages()\" [displayError]=\"m_displayError\"\n                        [displayMessage]=\"m_displayMessage\" [class]=\"m_messageHandlerClass\"></ebootis-message-handler>\n                </div>\n            </div>\n        </form>\n    </mat-card-content>\n</mat-card>\n\n<ng-template>\n    <!-- Dies wurde aus Sicherheitsgr\u00FCnden auskommentiert (05.09.2022).\n    Das Verfahren soll zun\u00E4chst (serverseitig) verfeinert und sicherer gemacht werden.\n    Danach k\u00F6nnen wir dies wieder anzeigen. In Template, damit dieser Kommentar nicht generiert wird-->\n    <!-- \n        <mat-card *ngIf=\"m_showTOTP && !m_qrCodeUrl\" class=\"mt-3\">\n            <div class=\"row mb-2\">\n                <div class=\"col-12\">\n                    <span class=\"mat-title\">{{m_loginIntl.noAuthAppTitle}}</span>\n                </div>\n            </div>\n            <div class=\"d-flex flex-column\">\n                <button mat-raised-button color=\"basic\" class=\"mb-2\" type=\"button\"\n                    (click)=\"send2FAScratchCode_Click()\">{{m_loginIntl.tfaScratchcodeButtonText}}</button>\n                <button mat-raised-button color=\"basic\" type=\"button\"\n                    (click)=\"reset2FA_Click()\">{{m_loginIntl.tfaResetButtonText}}</button>\n            </div>\n        </mat-card> \n    -->\n</ng-template>", styles: [".w-100{width:100%}.inline-spinner,.inline-spinner>.mdc-button__label{display:inline-flex;flex:0;flex-wrap:nowrap}.inline-spinner .mat-mdc-progress-spinner,.inline-spinner>.mdc-button__label .mat-mdc-progress-spinner{display:inline-block!important}\n"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RESET_PASSWORD_ROUTE]
            }] }, { type: LoginIntl, decorators: [{
                type: Optional
            }] }, { type: LoginService }, { type: LoginLibService }, { type: i4$1.FormBuilder }, { type: i2.MatDialog }, { type: LoginConfig }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [OFFLINE_DB_NAME]
            }] }, { type: i3.OnlineOfflineService, decorators: [{
                type: Optional
            }] }]; }, { loggedIn: [{
            type: Output
        }], formDirective: [{
            type: ViewChild,
            args: ['formDirective', { static: true }]
        }] }); })();

class ResetPasswordIntl {
    constructor() {
        this.changes = new Subject();
    }
    static { this.ɵfac = function ResetPasswordIntl_Factory(t) { return new (t || ResetPasswordIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ResetPasswordIntl, factory: ResetPasswordIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function ResetPasswordComponent_mat_error_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.m_loginRpwIntl.newPasswordErrorRequired);
} }
function ResetPasswordComponent_mat_error_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.m_loginRpwIntl.confirmPasswordErrorRequired);
} }
function ResetPasswordComponent_mat_error_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.m_loginRpwIntl.confirmPasswordErrorEqual);
} }
class ResetPasswordComponent {
    set hash(p_hash) {
        if (p_hash) {
            this.m_hash = p_hash;
            this.m_resetPwForm.get(this.HASH).setValue(p_hash);
            this.m_resetPwForm.updateValueAndValidity();
            this.changeDetector.detectChanges();
        }
    }
    get hash() {
        return this.m_hash;
    }
    constructor(loginRpwIntl, m_loginService, m_activatedRoute, m_router, m_formBuilder, changeDetector) {
        this.loginRpwIntl = loginRpwIntl;
        this.m_loginService = m_loginService;
        this.m_activatedRoute = m_activatedRoute;
        this.m_router = m_router;
        this.m_formBuilder = m_formBuilder;
        this.changeDetector = changeDetector;
        this.m_subscriptionsSubject = new Subject();
        this.m_messageHandlerClass = "info";
        this.HASH = "hash";
        this.NEW_PASSWORD = "newPassword";
        this.CONFIRM_PASSWORD = "confirmPassword";
        this.passwordReset = new EventEmitter();
        this.m_resetPwForm = this.m_formBuilder.group({
            [this.NEW_PASSWORD]: ['', Validators.required],
            [this.CONFIRM_PASSWORD]: ['', [Validators.required, this.passwordMatcher.bind(this)]],
            [this.HASH]: ['', Validators.required]
        });
        if (this.loginRpwIntl) {
            this.m_loginRpwIntl = this.loginRpwIntl;
        }
        else {
            this.m_loginRpwIntl = new ResetPasswordIntl();
            this.m_loginRpwIntl.titleText = 'Neues Passwort';
            this.m_loginRpwIntl.newPasswordPlaceholder = 'neues Passwort';
            this.m_loginRpwIntl.newPasswordErrorRequired = 'bitte neues Passwort angeben';
            this.m_loginRpwIntl.confirmPasswordPlaceholder = 'neues Passwort (Wiederholung)';
            this.m_loginRpwIntl.confirmPasswordErrorRequired = 'bitte neues Passwort wiederholen';
            this.m_loginRpwIntl.confirmPasswordErrorEqual = 'Passwörter nicht identisch';
            this.m_loginRpwIntl.saveButtonText = 'Speichern';
            this.m_loginRpwIntl.noHashError = 'Ungültiger Aufruf! Bitte rufen Sie den Link aus der E-Mail auf, oder lassen Sie sich eine neue E-Mail schicken.';
            this.m_loginRpwIntl.backButtonText = 'Zurück';
        }
        this.m_activatedRoute.queryParamMap.pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (params) => {
                if (params.has('q')) {
                    this.hash = params.get('q');
                }
            }
        });
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    passwordMatcher(p_control) {
        if (this.m_resetPwForm && (p_control.value !== this.getControl(this.NEW_PASSWORD).value)) {
            return { notEqual: true };
        }
        else {
            return null;
        }
    }
    resetPw_Submit() {
        this.m_loginService.newPassword(this.getControl(this.NEW_PASSWORD).value, this.m_resetPwForm.get(this.HASH).value).pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (res) => {
                if (res.retCode == 0) {
                    this.passwordReset.emit(true);
                }
            },
            error: (error) => {
                this.m_messageHandlerClass = "danger";
                this.m_displayError = error;
            }
        });
    }
    goBack() {
        this.m_router.navigate(['']);
    }
    getControl(p_name) {
        return this.m_resetPwForm.get(p_name);
    }
    clearDisplayMessages() {
        this.m_displayError = null;
    }
    static { this.ɵfac = function ResetPasswordComponent_Factory(t) { return new (t || ResetPasswordComponent)(i0.ɵɵdirectiveInject(ResetPasswordIntl, 8), i0.ɵɵdirectiveInject(LoginLibService), i0.ɵɵdirectiveInject(i3$2.ActivatedRoute), i0.ɵɵdirectiveInject(i3$2.Router), i0.ɵɵdirectiveInject(i4$1.FormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ResetPasswordComponent, selectors: [["ebootis-reset-password"]], inputs: { hash: "hash" }, outputs: { passwordReset: "passwordReset" }, decls: 30, vars: 21, consts: [[1, "row", "pb-2"], [1, "col-12"], [1, "mat-headline-6"], [3, "formGroup", "ngSubmit"], [1, "row"], ["appearance", "fill", 1, "w-100"], ["matInput", "", "type", "password", "autocomplete", "new-password", 3, "formControlName"], [4, "ngIf"], ["type", "hidden", 3, "formControlName", "value"], [3, "hidden", "displayMessage"], ["mat-raised-button", "", "type", "button", 1, "me-3", 3, "click"], ["mat-raised-button", "", "color", "primary", 3, "disabled"], [1, "row", "mt-3"], [3, "displayError", "dismiss"]], template: function ResetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card")(1, "div", 0)(2, "div", 1)(3, "mat-card-title", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(5, "form", 3);
            i0.ɵɵlistener("ngSubmit", function ResetPasswordComponent_Template_form_ngSubmit_5_listener() { return ctx.resetPw_Submit(); });
            i0.ɵɵelementStart(6, "div", 4)(7, "div", 1)(8, "mat-form-field", 5)(9, "mat-label");
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(11, "input", 6);
            i0.ɵɵtemplate(12, ResetPasswordComponent_mat_error_12_Template, 2, 1, "mat-error", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(13, "div", 4)(14, "div", 1)(15, "mat-form-field", 5)(16, "mat-label");
            i0.ɵɵtext(17);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(18, "input", 6);
            i0.ɵɵtemplate(19, ResetPasswordComponent_mat_error_19_Template, 2, 1, "mat-error", 7);
            i0.ɵɵtemplate(20, ResetPasswordComponent_mat_error_20_Template, 2, 1, "mat-error", 7);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(21, "input", 8)(22, "ebootis-message-handler", 9);
            i0.ɵɵelementStart(23, "button", 10);
            i0.ɵɵlistener("click", function ResetPasswordComponent_Template_button_click_23_listener() { return ctx.goBack(); });
            i0.ɵɵtext(24);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "button", 11);
            i0.ɵɵtext(26);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "div", 12)(28, "div", 1)(29, "ebootis-message-handler", 13);
            i0.ɵɵlistener("dismiss", function ResetPasswordComponent_Template_ebootis_message_handler_dismiss_29_listener() { return ctx.clearDisplayMessages(); });
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_loginRpwIntl.titleText);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formGroup", ctx.m_resetPwForm);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_loginRpwIntl.newPasswordPlaceholder);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.NEW_PASSWORD);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.NEW_PASSWORD).hasError("required"));
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.m_loginRpwIntl.confirmPasswordPlaceholder);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.CONFIRM_PASSWORD);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.CONFIRM_PASSWORD).hasError("required"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.getControl(ctx.CONFIRM_PASSWORD).hasError("notEqual"));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControlName", ctx.HASH)("value", ctx.hash);
            i0.ɵɵadvance(1);
            i0.ɵɵclassMap(ctx.m_messageHandlerClass);
            i0.ɵɵproperty("hidden", !ctx.getControl(ctx.HASH).hasError("required"))("displayMessage", ctx.m_loginRpwIntl.noHashError);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.m_loginRpwIntl.backButtonText);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("disabled", !ctx.m_resetPwForm.valid);
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate(ctx.m_loginRpwIntl.saveButtonText);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.m_messageHandlerClass);
            i0.ɵɵproperty("displayError", ctx.m_displayError);
        } }, dependencies: [i4$1.ɵNgNoValidate, i4$1.DefaultValueAccessor, i4$1.NgControlStatus, i4$1.NgControlStatusGroup, i4$1.FormGroupDirective, i4$1.FormControlName, i5.NgIf, i6.MatFormField, i6.MatLabel, i6.MatError, i10.MatCard, i10.MatCardTitle, i3$1.MatButton, i9.MatInput, i3.MessageHandlerComponent], styles: ["[_nghost-%COMP%]{height:100%}.translocate[_ngcontent-%COMP%]{margin-bottom:15vh}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResetPasswordComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-reset-password', template: "<mat-card>\n    <div class=\"row pb-2\">\n        <div class=\"col-12\">\n            <mat-card-title class=\"mat-headline-6\">{{m_loginRpwIntl.titleText}}</mat-card-title>\n        </div>\n    </div>\n    <form [formGroup]=\"m_resetPwForm\" (ngSubmit)=\"resetPw_Submit()\">\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <mat-form-field class=\"w-100\" appearance=\"fill\">\n                    <mat-label>{{m_loginRpwIntl.newPasswordPlaceholder}}</mat-label>\n                    <input matInput type=\"password\" autocomplete=\"new-password\" [formControlName]=\"NEW_PASSWORD\">\n                    <mat-error *ngIf=\"getControl(NEW_PASSWORD).hasError('required')\">{{m_loginRpwIntl.newPasswordErrorRequired}}</mat-error>\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-12\">\n                <mat-form-field class=\"w-100\" appearance=\"fill\">\n                    <mat-label>{{m_loginRpwIntl.confirmPasswordPlaceholder}}</mat-label>\n                    <input matInput type=\"password\" autocomplete=\"new-password\" [formControlName]=\"CONFIRM_PASSWORD\">\n                    <mat-error *ngIf=\"getControl(CONFIRM_PASSWORD).hasError('required')\">{{m_loginRpwIntl.confirmPasswordErrorRequired}}</mat-error>\n                    <mat-error *ngIf=\"getControl(CONFIRM_PASSWORD).hasError('notEqual')\">{{m_loginRpwIntl.confirmPasswordErrorEqual}}</mat-error>\n                </mat-form-field>\n            </div>\n        </div>\n        <input type=\"hidden\" [formControlName]=\"HASH\" [value]=\"hash\">\n        <ebootis-message-handler [hidden]=\"!getControl(HASH).hasError('required')\" [displayMessage]=\"m_loginRpwIntl.noHashError\" [class]=\"m_messageHandlerClass\"></ebootis-message-handler>\n        <button mat-raised-button type=\"button\" (click)=\"goBack()\" class=\"me-3\">{{m_loginRpwIntl.backButtonText}}</button>\n        <button mat-raised-button color=\"primary\" [disabled]=\"!m_resetPwForm.valid\">{{m_loginRpwIntl.saveButtonText}}</button>\n        \n    </form>\n    <div class=\"row mt-3\">\n        <div class=\"col-12\">\n            <ebootis-message-handler (dismiss)=\"clearDisplayMessages()\" [displayError]=\"m_displayError\" [class]=\"m_messageHandlerClass\"></ebootis-message-handler>\n        </div>\n    </div>\n</mat-card>", styles: [":host{height:100%}.translocate{margin-bottom:15vh}\n"] }]
    }], function () { return [{ type: ResetPasswordIntl, decorators: [{
                type: Optional
            }] }, { type: LoginLibService }, { type: i3$2.ActivatedRoute }, { type: i3$2.Router }, { type: i4$1.FormBuilder }, { type: i0.ChangeDetectorRef }]; }, { hash: [{
            type: Input
        }], passwordReset: [{
            type: Output
        }] }); })();

class UserDevicesIntl {
    constructor() {
        this.changes = new Subject();
    }
    static { this.ɵfac = function UserDevicesIntl_Factory(t) { return new (t || UserDevicesIntl)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserDevicesIntl, factory: UserDevicesIntl.ɵfac }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserDevicesIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

function UserDevicesComponent_mat_table_7_mat_header_cell_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.m_userDevicesIntl.deviceNameText);
} }
function UserDevicesComponent_mat_table_7_mat_cell_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell")(1, "span", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r11 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.m_userDevicesIntl.deviceNameText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", element_r11.name, " ");
} }
function UserDevicesComponent_mat_table_7_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.m_userDevicesIntl.verificationDateText);
} }
function UserDevicesComponent_mat_table_7_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell")(1, "span", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r12 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r4.m_userDevicesIntl.verificationDateText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, element_r12.verificationDate, "dd.MM.yyyy"), " ");
} }
function UserDevicesComponent_mat_table_7_mat_header_cell_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r5.m_userDevicesIntl.lastLoginText);
} }
function UserDevicesComponent_mat_table_7_mat_cell_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell")(1, "span", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r13 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.m_userDevicesIntl.lastLoginText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 2, element_r13.lastLogin, "dd.MM.yyyy"), " ");
} }
function UserDevicesComponent_mat_table_7_mat_header_cell_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r7.m_userDevicesIntl.removeText);
} }
function UserDevicesComponent_mat_table_7_mat_cell_12_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-cell")(1, "span", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 18);
    i0.ɵɵlistener("click", function UserDevicesComponent_mat_table_7_mat_cell_12_Template_button_click_3_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const element_r14 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r15.deleteDevice_Click(element_r14)); });
    i0.ɵɵelementStart(4, "mat-icon");
    i0.ɵɵtext(5, "delete");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r8.m_userDevicesIntl.removeText);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("matTooltip", ctx_r8.m_userDevicesIntl.removeTooltip);
} }
function UserDevicesComponent_mat_table_7_mat_header_row_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function UserDevicesComponent_mat_table_7_mat_row_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
} }
function UserDevicesComponent_mat_table_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-table", 6);
    i0.ɵɵelementContainerStart(1, 7);
    i0.ɵɵtemplate(2, UserDevicesComponent_mat_table_7_mat_header_cell_2_Template, 2, 1, "mat-header-cell", 8);
    i0.ɵɵtemplate(3, UserDevicesComponent_mat_table_7_mat_cell_3_Template, 4, 2, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(4, 10);
    i0.ɵɵtemplate(5, UserDevicesComponent_mat_table_7_mat_header_cell_5_Template, 2, 1, "mat-header-cell", 8);
    i0.ɵɵtemplate(6, UserDevicesComponent_mat_table_7_mat_cell_6_Template, 5, 5, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 11);
    i0.ɵɵtemplate(8, UserDevicesComponent_mat_table_7_mat_header_cell_8_Template, 2, 1, "mat-header-cell", 8);
    i0.ɵɵtemplate(9, UserDevicesComponent_mat_table_7_mat_cell_9_Template, 5, 5, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 12);
    i0.ɵɵtemplate(11, UserDevicesComponent_mat_table_7_mat_header_cell_11_Template, 2, 1, "mat-header-cell", 13);
    i0.ɵɵtemplate(12, UserDevicesComponent_mat_table_7_mat_cell_12_Template, 6, 2, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(13, UserDevicesComponent_mat_table_7_mat_header_row_13_Template, 1, 0, "mat-header-row", 14);
    i0.ɵɵtemplate(14, UserDevicesComponent_mat_table_7_mat_row_14_Template, 1, 0, "mat-row", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dataSource", ctx_r0.m_dataSource);
    i0.ɵɵadvance(13);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.m_displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.m_displayedColumns);
} }
class UserDevicesComponent {
    constructor(userDevicesIntl, m_userDeviceService, m_changeDetectorRef) {
        this.userDevicesIntl = userDevicesIntl;
        this.m_userDeviceService = m_userDeviceService;
        this.m_changeDetectorRef = m_changeDetectorRef;
        this.m_subscriptionsSubject = new Subject();
        this.m_messageHandlerClass = "info";
        this.m_displayedColumns = ['device', 'verification', 'login', 'tool'];
        if (this.userDevicesIntl) {
            this.m_userDevicesIntl = this.userDevicesIntl;
        }
        else {
            this.m_userDevicesIntl = new UserDevicesIntl();
            this.m_userDevicesIntl.titleText = 'Geräte verwalten';
            this.m_userDevicesIntl.deviceNameText = 'Gerätename';
            this.m_userDevicesIntl.verificationDateText = 'Registrationsdatum';
            this.m_userDevicesIntl.lastLoginText = 'letzter Login';
            this.m_userDevicesIntl.removeText = 'Gerät entfernen';
            this.m_userDevicesIntl.removeTooltip = 'Entfernen';
            this.m_userDevicesIntl.noDataText = 'keine Geräte vorhanden';
        }
    }
    ngOnInit() {
        this.getUserDevices();
    }
    ngOnDestroy() {
        this.m_subscriptionsSubject.next();
        this.m_subscriptionsSubject.complete();
    }
    getUserDevices() {
        this.m_userDeviceService.getUserDevices().pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (res) => {
                this.m_userDevices = res;
                this.m_dataSource = new MatTableDataSource(this.m_userDevices);
                this.m_changeDetectorRef.detectChanges();
            },
            error: (error) => {
                this.m_messageHandlerClass = "danger";
                this.m_displayError = error;
            }
        });
    }
    deleteDevice_Click(p_device) {
        this.m_userDeviceService.removeUserDevice(p_device).pipe(takeUntil(this.m_subscriptionsSubject)).subscribe({
            next: (res) => {
                if (res == null) {
                    this.getUserDevices();
                }
            },
            error: (error) => {
                this.m_messageHandlerClass = "danger";
                this.m_displayError = error;
            }
        });
    }
    clearDisplayMessages() {
        this.m_displayError = null;
    }
    static { this.ɵfac = function UserDevicesComponent_Factory(t) { return new (t || UserDevicesComponent)(i0.ɵɵdirectiveInject(UserDevicesIntl, 8), i0.ɵɵdirectiveInject(UserDeviceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserDevicesComponent, selectors: [["ebootis-user-devices"]], decls: 11, vars: 5, consts: [[1, "row"], [1, "col-12"], [1, "mat-headline-6"], [3, "dataSource", 4, "ngIf"], [1, "row", "mt-3"], [3, "displayError", "dismiss"], [3, "dataSource"], ["matColumnDef", "device"], ["mat-sort-header", "", 4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "verification"], ["matColumnDef", "login"], ["matColumnDef", "tool"], [4, "matHeaderCellDef"], [4, "matHeaderRowDef"], [4, "matRowDef", "matRowDefColumns"], ["mat-sort-header", ""], [1, "mobile-label"], ["mat-icon-button", "", 3, "matTooltip", "click"]], template: function UserDevicesComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-card")(1, "div", 0)(2, "div", 1)(3, "span", 2);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(5, "div", 0)(6, "div", 1);
            i0.ɵɵtemplate(7, UserDevicesComponent_mat_table_7_Template, 15, 3, "mat-table", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 4)(9, "div", 1)(10, "ebootis-message-handler", 5);
            i0.ɵɵlistener("dismiss", function UserDevicesComponent_Template_ebootis_message_handler_dismiss_10_listener() { return ctx.clearDisplayMessages(); });
            i0.ɵɵelementEnd()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.m_userDevicesIntl.titleText);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.m_userDevices);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.m_messageHandlerClass);
            i0.ɵɵproperty("displayError", ctx.m_displayError);
        } }, dependencies: [i5.NgIf, i4$2.MatTable, i4$2.MatHeaderCellDef, i4$2.MatHeaderRowDef, i4$2.MatColumnDef, i4$2.MatCellDef, i4$2.MatRowDef, i4$2.MatHeaderCell, i4$2.MatCell, i4$2.MatHeaderRow, i4$2.MatRow, i10.MatCard, i3$1.MatIconButton, i7.MatIcon, i8.MatTooltip, i3.MessageHandlerComponent, i5.DatePipe], styles: [".mat-mdc-table[_ngcontent-%COMP%]{overflow:auto;max-height:650px}.mobile-label[_ngcontent-%COMP%]{display:none}@media (max-width: 992px){.mobile-label[_ngcontent-%COMP%]{width:8rem;display:inline-block;font-weight:700}.mat-mdc-header-row[_ngcontent-%COMP%]{display:none}.mat-mdc-row[_ngcontent-%COMP%]{flex-direction:column;align-items:start;max-height:100%}.mat-mdc-cell[_ngcontent-%COMP%]{padding-left:1rem}.mat-mdc-cell[_ngcontent-%COMP%]:first-of-type{padding-left:1rem}}"] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserDevicesComponent, [{
        type: Component,
        args: [{ selector: 'ebootis-user-devices', template: "<mat-card>\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <span class=\"mat-headline-6\">{{m_userDevicesIntl.titleText}}</span>\n        </div>\n    </div>\n    \n    <div class=\"row\" >\n        <div class=\"col-12\">\n            <mat-table [dataSource]=\"m_dataSource\" *ngIf=\"m_userDevices\">\n                <ng-container matColumnDef=\"device\">\n                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{m_userDevicesIntl.deviceNameText}}</mat-header-cell>\n                    <mat-cell *matCellDef=\"let element\">\n                        <span class=\"mobile-label\">{{m_userDevicesIntl.deviceNameText}}</span>\n                        {{element.name}}\n                    </mat-cell>\n                </ng-container>\n\n                <ng-container matColumnDef=\"verification\">\n                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{m_userDevicesIntl.verificationDateText}}</mat-header-cell>\n                    <mat-cell *matCellDef=\"let element\">\n                        <span class=\"mobile-label\">{{m_userDevicesIntl.verificationDateText}}</span>\n                        {{element.verificationDate | date: 'dd.MM.yyyy'}}\n                    </mat-cell>\n                </ng-container>\n\n                <ng-container matColumnDef=\"login\">\n                    <mat-header-cell *matHeaderCellDef mat-sort-header>{{m_userDevicesIntl.lastLoginText}}</mat-header-cell>\n                    <mat-cell *matCellDef=\"let element\">\n                        <span class=\"mobile-label\">{{m_userDevicesIntl.lastLoginText}}</span>\n                        {{element.lastLogin | date: 'dd.MM.yyyy'}}\n                    </mat-cell>\n                </ng-container>\n\n                <ng-container matColumnDef=\"tool\">\n                    <mat-header-cell *matHeaderCellDef>{{m_userDevicesIntl.removeText}}</mat-header-cell>\n                    <mat-cell *matCellDef=\"let element\">\n                        <span class=\"mobile-label\">{{m_userDevicesIntl.removeText}}</span>\n                        <button mat-icon-button matTooltip=\"{{m_userDevicesIntl.removeTooltip}}\" (click)=\"deleteDevice_Click(element)\">\n                            <mat-icon>delete</mat-icon>\n                        </button>\n                    </mat-cell>\n                </ng-container>\n\n                <mat-header-row *matHeaderRowDef=\"m_displayedColumns\"></mat-header-row>\n                <mat-row *matRowDef=\"let row; columns: m_displayedColumns;\"></mat-row>\n            </mat-table>\n        </div>\n    </div>\n    \n    <div class=\"row mt-3\">\n        <div class=\"col-12\">\n            <ebootis-message-handler (dismiss)=\"clearDisplayMessages()\" [displayError]=\"m_displayError\" [class]=\"m_messageHandlerClass\"></ebootis-message-handler>\n        </div>\n    </div>\n</mat-card>", styles: [".mat-mdc-table{overflow:auto;max-height:650px}.mobile-label{display:none}@media (max-width: 992px){.mobile-label{width:8rem;display:inline-block;font-weight:700}.mat-mdc-header-row{display:none}.mat-mdc-row{flex-direction:column;align-items:start;max-height:100%}.mat-mdc-cell{padding-left:1rem}.mat-mdc-cell:first-of-type{padding-left:1rem}}\n"] }]
    }], function () { return [{ type: UserDevicesIntl, decorators: [{
                type: Optional
            }] }, { type: UserDeviceService }, { type: i0.ChangeDetectorRef }]; }, null); })();

class HttpTimeoutInterceptor {
    constructor(m_locale) {
        this.m_locale = m_locale;
    }
    /**
     * Speziell für login und logout wird für jeden Request ein timeout von 30 Sekunden gesetzt
     * Muss in App Module als HTTP_INTERCEPTOR definiert werden
     * @param req
     * @param next
     */
    intercept(req, next) {
        let locale = this.m_locale;
        const headersConfig = {
            'Content-Type': 'application/json;charset=utf-8',
            'Accept': 'application/json;charset=utf-8',
            'Accept-Language': locale
        };
        const request = req.clone({ setHeaders: headersConfig, withCredentials: true });
        if (request.url.includes('login') || request.url.includes('logout'))
            return next.handle(request).pipe(timeout(1000 * 30));
        else
            return next.handle(request);
    }
    static { this.ɵfac = function HttpTimeoutInterceptor_Factory(t) { return new (t || HttpTimeoutInterceptor)(i0.ɵɵinject(LOCALE_ID)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HttpTimeoutInterceptor, factory: HttpTimeoutInterceptor.ɵfac, providedIn: 'root' }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpTimeoutInterceptor, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();

class LoginLibModule {
    static forRoot() {
        return {
            ngModule: LoginLibModule,
            providers: [{
                    provide: SFX_SERVICE_INVOKER,
                    useClass: OpenModelServletService
                }
            ]
        };
    }
    static { this.ɵfac = function LoginLibModule_Factory(t) { return new (t || LoginLibModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LoginLibModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            CookieService,
            { provide: HTTP_INTERCEPTORS, useClass: HttpTimeoutInterceptor, multi: true },
        ], imports: [FormsModule,
            ReactiveFormsModule,
            CommonModule,
            MatDialogModule,
            MatTableModule,
            MatFormFieldModule,
            MatCardModule,
            MatButtonModule,
            MatIconModule,
            MatInputModule,
            MatCheckboxModule,
            MatTooltipModule,
            UtilitiesModule,
            MatProgressSpinnerModule] }); }
}
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LoginComponent,
                    ResetPasswordDialog,
                    ResetPasswordComponent,
                    ChangePasswordComponent,
                    UserDevicesComponent,
                    TryOfflineDialog
                ],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    CommonModule,
                    MatDialogModule,
                    MatTableModule,
                    MatFormFieldModule,
                    MatCardModule,
                    MatButtonModule,
                    MatIconModule,
                    MatInputModule,
                    MatCheckboxModule,
                    MatTooltipModule,
                    UtilitiesModule,
                    MatProgressSpinnerModule,
                ],
                exports: [
                    LoginComponent,
                    ResetPasswordDialog,
                    ResetPasswordComponent,
                    ChangePasswordComponent,
                    UserDevicesComponent
                ],
                providers: [
                    CookieService,
                    { provide: HTTP_INTERCEPTORS, useClass: HttpTimeoutInterceptor, multi: true },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoginLibModule, { declarations: [LoginComponent,
        ResetPasswordDialog,
        ResetPasswordComponent,
        ChangePasswordComponent,
        UserDevicesComponent,
        TryOfflineDialog], imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatDialogModule,
        MatTableModule,
        MatFormFieldModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        MatTooltipModule,
        UtilitiesModule,
        MatProgressSpinnerModule], exports: [LoginComponent,
        ResetPasswordDialog,
        ResetPasswordComponent,
        ChangePasswordComponent,
        UserDevicesComponent] }); })();

/*
 * Public API Surface of login-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChangePasswordComponent, ChangePasswordIntl, LoginComponent, LoginConfig, LoginIntl, LoginLibModule, LoginLibService, RESET_PASSWORD_ROUTE, REVISION, ResetPasswordComponent, ResetPasswordDialog, ResetPasswordDialogIntl, ResetPasswordIntl, UserDevicesComponent, UserDevicesIntl };
